<div class="row">
  <div class="col-md-4" *ngFor="let product of productList">
    <app-product-item [productItem]="product"></app-product-item>
  </div>
</div>